module.exports = __webpack_public_path__ + "resource/img/image027.20a24420.png";